var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"charge-main"},_vm._l((_vm.advList),function(item,index){return _c('div',{key:index,staticStyle:{"margin-top":"10px"}},[_c('AdvertBox',{staticStyle:{"width":"98%","margin":"0 auto"},attrs:{"data":item}}),(_vm.advList && (index + 1 < _vm.advList.length))?_c('el-divider',{staticStyle:{"width":"90%"}}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }